export const EXPERIMENT_METADATA_PATH_LOCAL_STORAGE_PREFIX =
  'ls:experiment_metadata_path:';
